import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable, InjectionToken } from '@angular/core';
import Debug from 'debug';
import { Observable } from 'rxjs';

const debug = Debug('modeso:aumico-i18n:LanguageInterceptor');
export const LANGUAGE_PROVIDER = new InjectionToken<ILanguageProvider>('LanguageInterceptor');

export interface ILanguageProvider {
    getCurrentLanguage(): string;
}

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {
    constructor(@Inject(LANGUAGE_PROVIDER) private languageProvider: ILanguageProvider) {}

    /**
     * intercept automatically all http request to the backend
     * and set the content-language header according to current language from url
     * @param req
     * @param next // to call next interceptor
     */
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const modifiedReq = req.clone({
            setHeaders: {
                'content-language': this.languageProvider.getCurrentLanguage(),
            },
        });
        debug('add language to request... ' + this.languageProvider.getCurrentLanguage());
        return next.handle(modifiedReq);
    }
}
